const INFO = {
	main: {
		title: "My Profile",
		name: "Dennis Paul",
		email: "denizpaul89@gmail.com",
		phone: "+61 451556147",
		logo: "../logo_new.png",
	},

	socials: {
		github: "https://github.com/",
		linkedin: "https://www.linkedin.com/in/dennis-m-p-74659b72/",
		stackoverflow: "https://stackoverflow.com/users/3020568/deniz",
	},

	homepage: {
		title: "Full-stack Mobile and Web app developer",
		description_part_1:
			"I am a skilled ",
		description_part_2:
			" Android developer, with more than 12 years of experience ",
		description_part_3:
			"translating innovative concepts into user-centric applications showcased in my dynamic portfolio. Beyond Android, I excel in ReactJS and Python for web development, complemented by foundational DevOps skills. My holistic software engineering approach seamlessly integrates mobile and web development, exemplified by smooth deployment practices, ensuring a cohesive and impactful user experience across platforms",
	},

	about: {
		title: "I’m Dennis. I live in Melbourne, love coding, love products.",
		description:
			"With over 12 years in IT, I am an adept Technical Lead and Full-Stack Developer specializing in mobile app development (Android, Java, Kotlin, Flutter, ReactJS). Proficient in cloud platforms like AWS and Firebase, I excel in the entire mobile development life cycle. My expertise extends to translating business requirements, ensuring top performance, and implementing quality processes. Collaborating with product managers and clients, I assess customer demand and usability. Operating in agile environments, I continually evaluate new technologies for enhanced efficiency. My commitment lies in delivering high-quality applications with superior performance and responsiveness.",
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [
		{
			title: "Primera Hora (News App)",
			description:
				"In the Primera Hora app you would find all Spanish local content for news, sports and entertainment. You will also find photos and videos related to everything that happens in the country. ",
			logo: "https://firebasestorage.googleapis.com/v0/b/sample-959f8.appspot.com/o/logos%2Fandroid.png?alt=media&token=6e938b43-01b0-4b19-8764-e15bca61cb80",
			linkText: "View Project",
			link: "https://play.google.com/store/apps/details?id=com.primera.android&hl=en&gl=US",
		},

		{
			title: "El Nuevo Día (News App)",
			description:
				"This application will keep you informed about news from Puerto Rico and the world. Here you will find the most complete coverage and breaking news alerts to always be informed. Also, you can share with your friends the news that interests you.",
			logo: "https://firebasestorage.googleapis.com/v0/b/sample-959f8.appspot.com/o/logos%2Fandroid.png?alt=media&token=6e938b43-01b0-4b19-8764-e15bca61cb80",
			linkText: "View Project",
			link: "https://play.google.com/store/apps/details?id=com.elnuevodia.androidapplication&hl=en&gl=US",
		},

		{
			title: "Telematics App",
			description:
				"Collects the user’s driving data from different sensors like GPS, OBD dongle and analyses the driving behavior. Implementation of analytical algorithms to detect braking, speeding and cornering events even in high-traffic areas.",
			logo: "https://firebasestorage.googleapis.com/v0/b/sample-959f8.appspot.com/o/logos%2Fandroid.png?alt=media&token=6e938b43-01b0-4b19-8764-e15bca61cb80",
			linkText: "View Project",
			link: "https://github.com",
		},

		{
			title: "GrowByDo",
			description:
				"Flutter application - Parent and children can use this application. Parents can manage tasks and pocket money for their children",
			logo: "https://firebasestorage.googleapis.com/v0/b/sample-959f8.appspot.com/o/logos%2Ficon_flutter.png?alt=media&token=39d6056a-1589-4b6e-994d-56cf1956cb06",
			linkText: "View Project",
			link: "https://play.google.com/store/apps/details?id=com.growbydo.learningskillsapp&hl=en&gl=US",
		},

		{
			title: "Digital Store Apps",
			description:
				"Helping the digital transformation of the retail company from the UK. Provide the ideas/solutions for the requirements in groceries Store which provides value to the customer.",
			logo: "https://firebasestorage.googleapis.com/v0/b/sample-959f8.appspot.com/o/logos%2Fandroid.png?alt=media&token=6e938b43-01b0-4b19-8764-e15bca61cb80",
			linkText: "View Project",
			link: "https://github.com",
		},
	],
};

export default INFO;
